import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  return (
    <div className="pt-24 pb-16 bg-growlyy-gray-light">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
          <Link to="/" className="inline-flex items-center text-growlyy-primary mb-6 hover:text-growlyy-secondary transition-colors">
            <FaArrowLeft className="mr-2" /> Retour à l'accueil
          </Link>
          
          <h1 className="text-3xl md:text-4xl font-bold text-growlyy-primary mb-8">CONDITIONS D'UTILISATION</h1>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold text-growlyy-primary mb-4">1. Objet</h2>
              <p className="text-growlyy-gray-dark mb-4">
                Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation du site web et des services proposés par Growlyy. 
                En accédant à notre site ou en utilisant nos services, vous acceptez sans réserve ces conditions.
              </p>
              <p className="text-growlyy-gray-dark">
                Growlyy est une agence de prospection qui propose à ses clients un dashboard dédié permettant de créer et suivre des campagnes 
                de prospection multicanal (email, LinkedIn, téléphone, SMS). En utilisant les services de Growlyy, le client consent expressément 
                à ce que Growlyy prospecte en son nom et pour son compte, conformément aux objectifs définis ensemble.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-growlyy-primary mb-4">2. Accès au service</h2>
              <p className="text-growlyy-gray-dark">
                Growlyy met à disposition une plateforme de prospection B2B basée sur l'intelligence artificielle. 
                L'accès au service est réservé aux professionnels et nécessite la création d'un compte utilisateur.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-growlyy-primary mb-4">3. Obligations de l'utilisateur</h2>
              <p className="text-growlyy-gray-dark">
                L'utilisateur s'engage à fournir des informations exactes lors de l'inscription et à ne pas utiliser 
                le service à des fins frauduleuses ou illicites.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-growlyy-primary mb-4">4. Responsabilités</h2>
              <p className="text-growlyy-gray-dark">
                Growlyy ne pourra être tenu responsable des dommages résultant de l'utilisation de la plateforme, 
                notamment en cas d'erreur dans les données collectées ou d'interruption du service.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-growlyy-primary mb-4">5. Modification des conditions</h2>
              <p className="text-growlyy-gray-dark">
                Growlyy se réserve le droit de modifier ces CGU à tout moment. Les utilisateurs seront informés de toute 
                modification et devront accepter les nouvelles conditions pour continuer à utiliser les services.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-growlyy-primary mb-4">6. Loi applicable</h2>
              <p className="text-growlyy-gray-dark">
                Les présentes CGU sont soumises au droit français. En cas de litige, les tribunaux compétents 
                seront ceux du siège social de Growlyy.
              </p>
            </section>
          </div>
          
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-growlyy-gray-dark text-sm">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 